<script>
    import { Fragment as fragment } from 'vue-fragment';
    import { DisclaimerSection } from "../../Models/disclaimerClasses"
    import f9link from "inputs/f9link.vue";

    export default {
        props: {
            termsAndConditionsHyperlink:
            {
                type: String,
                default: "https://www.flyfrontier.com/frontiermiles/terms-and-conditions"
            },
            disclaimerSection: {
                type: DisclaimerSection,
                default: null
            }
        },
        components: {
            f9link,
            fragment
        }
    }
</script>

<template>
    <fragment>
        <li v-for="(item, index) in disclaimerSection.htmlDescriptionArray" :key="disclaimerSection.id + index" :value="item" v-html="item" />
        <li>
            <span>You agree to Frontier</span>           
            <f9link class="hyperlink-force-pointer-events" :underline="true" href="https://www.flyfrontier.com/legal/privacy-policy" target="_blank">
                Privacy Policy
            </f9link>
            and
            <f9link class="hyperlink-force-pointer-events" :underline="true" href="https://www.flyfrontier.com/legal/california-privacy-policy#Financial%20Incentive%20Programs" target="_blank">
                California Privacy Policy
            </f9link>.
        </li>
    </fragment>
</template>

<style lang="less" scoped>
    .hyperlink-force-pointer-events {
        pointer-events: all;
    }
</style>